export function isUploadedPaper(paperId: string) {
  return paperId.startsWith("u:");
}
